/**
 * Added to products like the adjustable clothrail
 * that can be adjusted in the planner.
 */
class AdjustableComponent {
    constructor() {
        this.typeId = AdjustableComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
AdjustableComponent.id = 3006;
export default AdjustableComponent;
//# sourceMappingURL=AdjustableComponent.js.map